module.exports = __webpack_public_path__ + "img/Batsu_Cercle.c5866f99.png";